<template>
    <div class="cancelBox">
        <ul>
            <li class="pay">
                <header>{{ $t("cancelAccount.userTitle") }}</header>
                <p>{{ $t("cancelAccount.userContent") }}</p>
            </li>
            <li class="pay">
                <header>{{ $t("cancelAccount.statementTitle") }}</header>
                <p>{{ $t("cancelAccount.statementContent") }}</p>
            </li>
            <li class="pay">
                <header>{{ $t("cancelAccount.convalescenceTitle") }}</header>
                <p>{{ $t("cancelAccount.convalescenceContent") }}</p>
            </li>
            <li class="pay">
                <header>{{ $t("cancelAccount.accountRecoveryTitle") }}</header>
                <p>{{ $t("cancelAccount.accountRecoveryContent") }}</p>
            </li>
            <li class="pay">
                <header>{{ $t("cancelAccount.reserveTitle") }}</header>
                <p>{{ $t("cancelAccount.reserveContent") }}</p>
            </li>
            <li class="pay">
                <header>{{ $t("cancelAccount.finalTitle") }}</header>
                <p>{{ $t("cancelAccount.finalContent") }}</p>
            </li>
        </ul>
        <footer>
            {{  $t("cancelAccount.confirmCancellation")  }}
        </footer>
    </div>
   
  </template>
  
  <script>
  export default {
    name: "cancelAccount",
    data() {
      return {
        langType: "",
      };
    },
    created() {
        this.langType = this.$route.query.langType;
        this.language()
    },
    mounted() {
    },
    methods: {
        language() {
            let langs = this.langType.substring(0, 2);
            let lang = this.langType;
            if (langs == "zh") {
                if (lang == "zh_TW" || lang == "zh_HK") {
                this.$i18n.locale = "tc";
                } else {
                this.$i18n.locale = "zh";
                }
            } else if (langs == "en") {
                this.$i18n.locale = "en";
            } else if (langs == "ar") {
                this.$i18n.locale = "ar";
            }else if (langs == "tr") {
                this.$i18n.locale = "tr";
            } else if (langs == "es") {
                this.$i18n.locale = "es";
            } else if (langs == "pt") {
                this.$i18n.locale = "pt";
            } else if (langs == 'fr') {
                this.$i18n.locale = 'fr'
            } else {
                this.$i18n.locale = "en";
            }
             document.querySelector("html").setAttribute("lang", this.$i18n.locale);
        },
    },
  };
  </script>
  
  <style scoped>
  html[lang="ar"] .cancelBox {
  -webkit-transform: rotateY(180deg);
}
html[lang="ar"] .cancelBox ul {
  -webkit-transform: rotateY(180deg);
}

html[lang="ar"] .body {
  direction: rtl;
}

html[lang="ar"] .pay {
  direction: rtl;
}
  * {
    margin: 0;
    padding: 0;
  }
  .cancelBox{
    width: 6.4rem;
    padding: 0.4rem 0.28rem;
    box-sizing: border-box;
  }
    li{
        margin-bottom: 0.32rem;
        font-size: 0.2rem;
        font-family: "PingFang SC";
        color: #000;
        line-height: 0.3rem;
        header{
            font-weight: bold;
            margin-bottom: 0.08rem;
        }
        p{
            font-weight: 400;
        }
    }
    footer{
        margin-bottom: 0.32rem;
        font-size: 0.2rem;
        font-family: "PingFang SC";
        color: #000;
        line-height: 0.3rem;

    }
  
  </style>
  